import request from "@/utils/request";

// 查询出品部订单列表
export function businessProduceOrderList(query) {
  return request({
    url: "/business/produceOrder/list",
    method: "get",
    params: query,
  });
}

// 接单
export function businessReceivingOrders(id) {
  return request({
    url: "/business/produceOrder/receiving/orders/" + id,
    method: "post",
  });
}

// 出品
export function businessProduceOrderProduce(id) {
  return request({
    url: "/business/produceOrder/produce/" + id,
    method: "post",
  });
}

// 查询水吧出品部订单列表
export function businessProduceOrderWaterBarList(params) {
  return request({
    url: "/business/produceOrder/waterBar/list",
    method: "get",
    params,
  });
}

// 获取语音合成的token
export function audioToken(data) {
  return request({
    url: "/send/post",
    method: "post",
    data,
  });
}

// 文字转语音
export function textToSpeech(data) {
  return request({
    url: "/send/textToAudio",
    method: "post",
    data,
  });
}

// 文字转语音
export const text2Audio = (data) => {
  return request({
    url: "/small/voiceCache/text2Audio",
    method: "post",
    data,
  });
};

// 处理消息
export const callServiceMessage = (data) => {
  return request({
    url: "/call/callServiceMessage",
    method: "put",
    data,
  });
};
